import type { Icon } from '@change/ds-icons';
import { GroupsIcon, SendIcon, SpeakerFilledIcon } from '@change/ds-icons';

import type { TranslationKey } from '@change-corgi/core/i18n';
import { translationKey } from '@change-corgi/core/i18n';

export type BulletPoint = {
	Icon: React.FC<Icon>;
	label: TranslationKey;
	size: Icon['size'];
};

export const BULLET_POINTS: BulletPoint[] = [
	{
		Icon: SendIcon,
		label: translationKey('corgi.petition.starter_dashboard_v2.post_an_update.header.bullet_share_with_friends'),
		size: 'medium',
	},
	{
		Icon: GroupsIcon,
		label: translationKey('corgi.petition.starter_dashboard_v2.post_an_update.header.bullet_contact_decision_maker'),
		size: 'medium',
	},
	{
		Icon: SpeakerFilledIcon,
		label: translationKey('corgi.petition.starter_dashboard_v2.post_an_update.header.bullet_celebrate_milestones'),
		size: 'small',
	},
];
